import { render, staticRenderFns } from "./excellentwork.vue?vue&type=template&id=9d015ec0&scoped=true"
import script from "./excellentwork.vue?vue&type=script&lang=js"
export * from "./excellentwork.vue?vue&type=script&lang=js"
import style0 from "./excellentwork.vue?vue&type=style&index=0&id=9d015ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d015ec0",
  null
  
)

export default component.exports